import Controller from '@ember/controller'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'

export default class ReportingReadingEggsController extends Controller {
  @service router!: RouterService

  get isDashboardTable() {
    return this.router.currentRouteName === 'reporting.ui-scope.re.dashboard.table'
  }
}
